module.exports = __webpack_public_path__ + "static/media/img2.8a0c43f1.jpg";